export enum B2bJoinModes {
  LOADING = 'loading',
  REGISTRATION = 'registration',
  ADD_NEW_CC = 'insertcreditcard',
  OTL = 'otl'
}
